<template>
  <div class="container page lottery" style="width: 100%; padding-bottom: 2px; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <div style="overflow: hidden;width: 100%;position: relative;z-index: 2;background: url(/img/home/233.png) no-repeat top / 100%;"><van-nav-bar :title="lottery.name" class="nav-bar" style="height: 46px;line-height: 46px">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
        <!-- <template #right>
           <div class="right" @click="showRight">{{ $t('reservation.switching_window') }}</div> 
       </template> -->
    </van-nav-bar>
    <div class="record" style="">
      <div class="period">
        <van-image class="cover" :src="lottery.ico" style="display:none">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
        <span class="period-number">{{ lottery.now_expect }}</span>
        <div class="next-number" >
          <!-- <span>{{this.lottery.next_expect}}</span> -->
          <van-count-down :time="time" @finish="check()" style="color:#20d917;font-size: 14px;"/>
        </div>
      </div><div
        
        class="numberBox"
        style="
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqoAAACICAYAAAAvfsl+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgOS4wLWMwMDAgNzkuMTcxYzI3ZiwgMjAyMi8wOC8xNi0xODowMjo0MyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDI0LjAgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMy0wMi0wNlQyMzoyMzo0OCswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDItMDZUMjM6MzE6MDQrMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDItMDZUMjM6MzE6MDQrMDg6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1NjA3Y2RjLWEyMzItZGQ0ZS1iMzIwLWM1Y2RhOGM4ZjNiMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0NTYwN2NkYy1hMjMyLWRkNGUtYjMyMC1jNWNkYThjOGYzYjMiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0NTYwN2NkYy1hMjMyLWRkNGUtYjMyMC1jNWNkYThjOGYzYjMiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ1NjA3Y2RjLWEyMzItZGQ0ZS1iMzIwLWM1Y2RhOGM4ZjNiMyIgc3RFdnQ6d2hlbj0iMjAyMy0wMi0wNlQyMzoyMzo0OCswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDI0LjAgKFdpbmRvd3MpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PudojcsAAAo7SURBVHic7d1bb93Wmcfh/yK3rJPlg5xkWqNw3QwGA7Tf/6O0wFxMaxgdN+NJ5IOsk/cm37nQVsZJHUfS3ono0fMAupFIgnf64V3kYstPqKo7SXbfvs2j2Sz3hpbt1jJL0v3UOQAA8AlDVeZ95XSxyGGSg3v38q619v5jB7cf/6KqWpK9w8M8ziz7rWUjSdcuArX98zkAAPCzKlVJ5fxn7CvzxSIHe3t5keRda2388PAfRGdV9UdH+XLo8vuuZeciTpcXhM9Ka5ef/ldl/PmjAIB1acsOrWQcK8ezyvOdnbxsrQ0fHHOuqvqTkzxeJE+6lq3liQIVAIBfzEWwjsnZRvJ8ayv/dRGrs+R8uf/4OF8tJ6lbpksAAPwaLgajXcvWvPJkPM68qr5prVWXJAcH2WsbedIlmyIVAIBfW1XGLtlsG3lycJC9JOn+XHVnYyOPhyE7lvoBALgpldQwZGdjI4//XHWn+2OyO5tlv9l2CgCAG9aSbjbL/h+T3e7sLPvD+RZUAABw44aWjbOz7HfDkPtJOsv+AADctGWTdsOQ+93Qsm3ZHwCAqWhJN7Rsd61l5mtTAABMRktrLbMupqkAAExPJ1IBAJgkoQoAwCQJVQAAJkmoAgAwSUIVAIBJEqoAAEySUAUAYJKEKgAAkyRUAQCYJKEKAMAkCVUAACZJqAIAMElCFQCASRKqAABMklAFAGCShCoAAJMkVAEAmCShCgDAJAlVAAAmSagCADBJQhUAgEkSqgAATJJQBQBgkoQqAACTJFQBAJgkoQoAwCQJVQAAJkmoAgAwSUIVAIBJ6pK0m74JAABoSWtJyyItSZslGVLLXyappG72FgEAuC0+aNCxkjFJpU+XZJyN7/Oi38pWN2R70bLZkr4l/fIE0QoAwFp9EKfDmAyzytnQ53g8zVlVFltb5xPVVlWzJO3Zs/SPnmY3h/kis+y3lq2WdGIVAIB1aUmrZKzKaRY5yF6+/e5Zjp4+zZDz7qwPjv2hqpodHGRnYze/TeXLLtkUqwAArKolbUzO0vI/86P8Y38/x621xSeO/7iqmh0d5VG7kyfjkL1f5nYBALgtuj6H9T7Pd3fz3acC9cIn3/ivqvbqVe61zXw96/LAowAAAFzFxVL/YszrOstfHz7M29bapXryUltTvay6uzPPv9aQR6vdKgAAt03r893xRv7zq9beXem8yx5YVXvHx/n36nLfVBUAgJ/TktbGvNnZyX+01g6vev6lv0zVWjscdvK3sXLSfCQAAIBPaEkbKyfDTv52nUhNrvgJ1b3k9UbLi0oWYhUAgI9ZPpe62Gh5sZe8vu51rhSqrbVhayvftD5vLP8DAPAxlVTr82ZrK9+01obrXudKobp0Vmd5UcncVBUAgA8tp6nzOsuLJGerXOvKodpaq7t387obTFUBAPihSqob8ubu3by+7DZUP+U6E9UkmWc3/z0zVQUAYKklbbbsxCTzVa93rVBtrdVu8mbsc2KqCgDAhbHPyW7yZtVpanL9iWqSzOfHeZXk2g/IAgDw/0clw+Ikr7OGaWqyQqi21oZ2P69myWD5HwDgdlu+RDW0e3m1ypv+H1plopp7yfH7Wk8xAwDweavK+73kaF3XWylUkwxdn6NKxrXcDQAAn6VKxq7PUdb4WOiqoToOJzlOMlr+BwC4nZYd+H0Xruu6K4fqfCMn8eY/AMBtV8suXFuozlY5ubVWVXV6eprRq/8AALfXLBm/2MnpOralurDqRDVJ5lWpNEv/AAC3UkurSmVN21JdWEeoGqYCAJCsuQtXDtW//z1ZrONOAAD4bC1y3oXrtI6JKgAArN3Kofq73634RhYAAJ+9Wc67cJ3WMVHt13ANAAA+f2vtwnWE6kZraSl7qQIA3EqVauc7QG2s87IrhWpVtW+Ps7XwrCsAwK22SLqjo2xW1dq2LF01MLuNebbj86kAALdd6/tsZ40DzJVDtd/OTpKufEYVAOBWWnZgt+iymwmFaj8O2W2W/gEAbrWWdOOQ3azxhaqVAvNtsnOnrfehWQAAPk+t5c5hsruu6107VKuqrzd5uEh6y/4AALdbJdWSvt7mYVWtZaq6ykR1Y2MnD2MfVQAAkrSkn23nQda0TdW1QrWq2lFyvxuy3bzxDwDAUjdk+yi5v45tqq47Ud3IUf5lkWxY9gcAIDlf/l8sOzFrmKpeOVSrqr17lwdjn/umqQAAfKglbexz/927PFh1qnqdiepm28zjZpoKAMCPLF+q2mibeZxkc5VrXSlUq6o/Pc1vajBNBQDg41rSasj909P8ZpUdAK4UqofJg3nlcUtmpqkAAHzMcqo6m1ceHyYPrnudS4dqVe31x/lD17ItUgEA+JRKqmvZ7o/zh6rau841LhWqL6vuHs3z9djlnkgFAOAyKqmxy72jeb5+WXX3qud/8jnTqmqvXuVe28zXsy4PWtIJVQAALqslrZJxMeZ1neWvDx/mbWvtUj35k6FaVbOjozxqd/JkHHKtcS0AAFzo+hzW+zzf3c13rbXFzx3/T6FaVbNvv8325l5+m8pXXbJpigoAwKpa0sbkLC0v9zbzjyQnnwrWVlWzJO3Zs/SPnmY3h/kis+y3li1L/QAArNPFowBVOc0iB9nLt989y9HTpxly3p3ft2d786b+rd/KVjdke9Gy2ZK+JX3OjxKpAACs1cV+/JUMlQyzytnQ53g8zVlVFltbaUnarLuTxxkzG9v5FgCVlEAFAOCX8kFrdl3Sjy13Mma3u3M+UZ1XuiTjLEmfllaV8eZuFwCA2+iDaG3tYuvUIV31GZZDVAAAuFnfr+zPzierV/qEKgAA/FqEKgAAkyRUAQCYJKEKAMAkCVUAACZJqAIAMElCFQCASRKqAABMklAFAGCShCoAAJMkVAEAmCShCgDAJAlVAAAmSagCADBJQhUAgEkSqgAATJJQBQBgkoQqAACTJFQBAJgkoQoAwCQJVQAAJkmoAgAwSUIVAIBJEqoAAEySUAUAYJKEKgAAkyRUAQCYJKEKAMAkCVUAACapSzLe9E0AAMCPjF1VFqnUTd8JAAAkSSpVlUXXV07KVBUAgImoZOwrJ13f502SsSXtpm8KAIDbbdmkY9/nTbe5mYO+Mr/pmwIAgCTpK/PNzRx0f0mOFoscWP4HAOCmVTIuFjn4S3LU/am19/N5XvR9ji3/AwBwU1rS+j7H83le/Km1912S7O/nsOZ5PiZnrdlbFQCAX1dr6cbkrOZ5vr+fwySZnf+hVVW9PDnJbFF50rVsJUnFtlUAAPxyLlb0x8rpRvJ8aycvW2u1/Nv/qar+6ChfDl1+37XstOWXqwQrAADrdBGolYxj5XhWeb5zHqnDB8f8UFW1JHuHh3mcWfZby0aSriVdmmdY+XxUXf4FQY+8AMCvpFLLl/jHvjJfLHKwt5cXSd611n7wv/snw7Oq7iTZffs2j2az3BtatpfRKlb5LLSW/rLHVmX4+aMAgBVVVeZ95WSxyNskB/fu5V1r7f3HDv5fyE0YRhjqOmQAAAAASUVORK5CYII=) no-repeat 50% / 100%;;
          padding: 12px;
          margin-bottom: 10px;
          border-radius: 8px;
          display: flex;
          align-items: center;
        "
      >
        <div
          
          style="
            border-right: 4px solid rgb(249, 177, 231);
            padding: 0px 30px 0px 10px;
            color: rgb(255, 255, 255);
            font-weight: bold;
            font-size: 16px;
            text-align: center;
          "
        >
          <div >{{ lottery.now_expect}}</div>
          <div >{{ $t('reservation.voting_results') }}</div>
        </div>
        <div  class="resBox">
          <div  class="resItem">{{ sum }}</div>
          <div >
            <div
              
              class="ressquareBox"
              style="margin: 0px 0px 5px; min-width: 70px;"
            >
              {{ size }}
            </div>
            <div  class="ressquareBox" style="margin: 0px;">
              {{double}}
            </div>
          </div>
     
          <van-icon name="arrow-down"  :class="{ up: active,down:!active }" @click="active ? active = false : active = true" style="margin-left: auto;" />
        </div>
      </div>

    </div></div>
    <div class="record-link" @click="$router.push({ path: '/GameRecord' })">
      <span>{{ $t("my.task_record") }}</span>
      <van-icon name="arrow" />
    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
        
          <div
            class="linear-gradient"
            style="
              background: linear-gradient(
                to right,
                rgba(126, 86, 120, 0),
                rgb(230, 195, 161),
                rgba(126, 86, 120, 0)
              );
            "
          ></div>
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in displayPeilvList"
              :key="key"
              @click="choosePlay(v.type, v.type)"
            >
            
              <div class="wrapper">
                <div class="content">
                  <div class="name-text large">{{ getPlayLabel(v.type) }}</div>
                  <div class="odd-text large">({{ v.proportion || '1.98' }})</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div
              class="item"
              @click="shopping ? (shopping = false) : (shopping = true)"
            >
              <van-icon name="cart-o" class="jixuanico" />
            
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text" style="margin-right: 6px;">{{ $t("reservation.available_balance") }}:</span>
            <span class="text num">{{ this.userInfo.money }}</span>
           
          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>
        <div class="wrapper" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="bet-number">{{ convertedShopchoose  }}</div>
            <van-icon
              name="arrow-down"
              :class="{ up: !shopping, down: shopping }"
              @click="shopping ? (shopping = false) : (shopping = true)"
            />
          </div>
          <div class="item">
            <span class="label">{{ $t("reservation.per_price") }}</span>
            <div class="amount-wrapper">
              <van-field
                v-model="money"
                type="digit"
                :placeholder="$t('reservation.price_place')"
              />
              
            </div>
          </div>
          <!-- <div class="item">
            <div class="part">
              <span>{{ $t("reservation.total") }}</span>
              <span class="number">{{ this.formData.length }}</span>
              <span>{{ $t("reservation.note") }}</span>
            </div>
            <div class="part">
              <span>{{ $t("reservation.total") }}</span>
              <span class="number">{{
                this.formData.length * this.money
              }}</span>
              <span>{{ $t("reservation.unit") }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <div class="head van-hairline--bottom" style="color: #fff;background: linear-gradient(133deg, #e64588, #f22678);">
            <p class="text" style="color:#fff">{{ $t("reservation.task_list") }}</p>
          </div>
          <ui class="list">
            <li
              v-for="(v, key) in formData"
              :key="key"
              class="lise-item van-hairline--bottom"
            >
              <div class="main" style="">
                <p class="bet-name" style="color: #f6379c;line-height: 16px;font-size: 12px;">{{ getPlayLabel(v.type) }}</p>
                <p class="detail-text" style="color:#5739ab;line-height: 14px;">
                  1{{ $t("reservation.note") }}X{{ money
                  }}({{ $t("reservation.unit") }})={{ money
                  }}({{ $t("reservation.unit") }})
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>
          <div class="sub-bar">
            <van-button
              class="item cancel-btn"
              type="default"
              @click="allClear()"
              >{{ $t("reservation.clear_order") }}</van-button
            >
            <van-button class="item sub-btn" style="background: linear-gradient(133deg, #e64588, #f22678);" type="default" @click="doSub">{{
              $t("reservation.submit")
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '100%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight" style="font-size: 12px;">{{ $t("reservation.num") }}</div>
              <div class="right font-weight" style="font-size: 12px;">
                {{ $t("reservation.win_num") }}
              </div>
            </div>
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
            
                  <span class="ballBox">{{ v.opencode[0] }}</span>
                  <span class="ballBox">{{ v.opencode[1] }}</span>
                  <span class="ballBox" style="margin-right: 20px;">{{ v.opencode[2] }}</span>
              
            
                  <span class="res-des ">{{
                    v.opencode[0] + v.opencode[1] + v.opencode[2]
                  }}</span>
                  <span
                    class=" middle"
                    >{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? rose :lily }}</span
                  >
                  <span class=" middle">{{
                    (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                      ? balloon
                      : fireworks
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
 
    </div>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%',height:'100%' }">
       <div class="list">
        
          <div class="item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
              <div>연결 활동</div>
              <div style="margin: 15px 0 0 15px;">
                <div style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
                  <van-image
  width="60"
  height="61"
  :src="i.ico"
  style=""
/>
                </div>
  
<div style="font-size: 14px;">{{ i.name }}</div>
              </div>
            </div>
       
          
       </div>
      </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks:"",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: this.$route.query.id,
      keys: this.$route.query.key,
      gameitemData: [],
      redirectAfterDraw: false,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    syncLocalizedLabels() {
      this.rose = this.$t("reservation.big");
      this.lily = this.$t("reservation.small");
      this.balloon = this.$t("reservation.double");
      this.fireworks = this.$t("reservation.single");
    },
    getPlayLabel(type) {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };

      return mapping[type] || type;
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              localStorage.setItem(this.gameRecordExpectKey, this.lottery.now_expect);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {
      
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose)
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        console.log(this.shopchoose, 'ssss')
      
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.redirectAfterDraw = true;
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id:this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("lottery_peilv_list:",this.lottery_peilv_list);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log("lottery_list:");
          console.log(res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitemData = res.data;console.log(this.lang);
        console.log(this.gameitemData,'gameitemData')
      })
    },
    tabList(id,key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = this.$t("auth.lang");
        if (res.code === 200) {
          if (
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
          const pendingExpect = localStorage.getItem(this.gameRecordExpectKey);
          if (
            this.redirectAfterDraw &&
            pendingExpect &&
            String(res.data.now_expect) !== String(pendingExpect)
          ) {
            localStorage.removeItem(this.gameRecordExpectKey);
            this.redirectAfterDraw = false;
            clearInterval(time);
            count = 0;
            this.$router.push({ path: "/GameRecord" });
            return;
          }
           console.log(this.lottery,'qweqweqw');
          this.time = res.data.second * 1000;if(lanng=='en'){this.lottery.name=res.data.name_es
}
		if(lanng=='ja'){
  this.lottery.name=res.data.name_ja
}
if(lanng=='kr'){
  this.lottery.name=res.data.name_kr
}if (this.time / 1000 === 59) {
            this.$toast(
              this.$t("reservation.prize_succ") + this.lottery.now_expect
            );
          }
          
          this.sum =
            res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
             console.log(this.sum,'sum')
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.$t("reservation.big");
         
          } else if (this.sum >= 3 && this.sum <= 10) {
              this.size = this.$t("reservation.small");
           
          }
          if (this.sum % 2 === 0) {
             this.double = this.$t("reservation.double");
              
          } else {
              this.double = this.$t("reservation.single");
            
         
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        console.log(this.lottery,9900)
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem()
      this.getLotteryInfo();
      this.getLotteryList();
    }
    this.syncLocalizedLabels();

  },
  computed: {
    gameRecordExpectKey() {
      return `game_record_expect_${this.keys || "default"}`;
    },
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };
   
      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    displayPeilvList() {
      const list = Array.isArray(this.lottery_peilv_list)
        ? this.lottery_peilv_list
        : Object.values(this.lottery_peilv_list || {});
      const fallback = ["big", "small", "one", "two"].map(type => ({
        type,
        proportion: "1.98"
      }));

      return list.length > 0 ? list : fallback;
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
 
  line-height: 60px;
}
.lottery {
  background: url("/img/lotterybg.png") no-repeat
    top;
  background-size: contain;
}
.lottery .van-nav-bar {
  background:none;
}
.record {
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0 4px 4px 0 #cacaca;
  z-index: 1;
}
.record .period {
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
}
.record .period .cover {
  width: 104px;
  height: 104px;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number {
  flex: 1;
  margin-left: 40px;
  margin-right: 20px;
  height: 50px;
  line-height: 50px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}
.van-count-down {
  color: #f4d70a;
  font-size: 45px;
  margin-top: 10px;
  float: right;
}
.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));

}
.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all 0.5s;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar {
  display: flex;
  align-items: center;
  height: 100%;
 
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}
.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient {
  width: 100%;
  height: 2px;
}
.record-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  margin: 12px 16px 0;
  padding: 0 18px;
  color: #7d7c7c;
  font-size: 22px;
  font-weight: 700;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .08);
}
.record-link .van-icon {
  color: #f6379c;
  font-size: 24px;
}
.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  width: calc(50% - 7vw) !important;
    height: 21vw !important;
    line-height: normal;
    text-align: center;
    background: #fff;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
    margin: 0 0 4vw 4%;
    width: 20%;
    border-radius: 20px;
}
.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
  height: 100%;
  background: #fff;
}
.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
}
.rectangle.large .wrapper {
  height: 100%;
  padding-bottom: 0;
}
.rectangle .wrapper .content .name-text.large {
  font-size: 30px;
  line-height: 1;
}
.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
 
}
.rectangle .wrapper .content .odd-text.large {
  display: block;
  font-size: 24px;
  margin: 0;
  line-height: 1;
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
  font-weight: 700;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 100px;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}
.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}
.jixuanico {
  font-size: 45px;
}
.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}
.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #000;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}
.bottom-bar .bar .right {
  padding: 0 10px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(180deg, #fc78af, #f22678);
  font-size: 28px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 16px;
}
.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
::v-deep .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep .van-popup--top {
  top: -1px;
}
.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.wrapper .item .left {
  width: 30%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}
.font-weight {
  font-weight: 700 !important;
}
.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}
.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.wrapper .item .kuaisan-ball .res-des {
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
    width: 7vw;
    border-radius: 50%;
}
.middle{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}
.rectangle.active .wrapper {
  background:linear-gradient(180deg, #fc78af, #f22678) !important;
}
.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}
.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 180px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
}
.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}
.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #000;
}
.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ed37ae;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.van-cell {
  font-size: 30px;
  line-height: 50px;
}
.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #ff253f;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 0px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}
.confirm-order-modal .head {
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 30px;
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 30px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}
.confirm-order-modal .list .lise-item {
  color: #ff253f;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #666;
  color: #000;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}
.numberBox .resBox{
  display: flex;
    align-items: center;
    background: none;
    border-radius: 16px;
    padding: 16px;
    height: 100%;
    margin-left: 10px;
    width: calc(100% - 37vw);
    box-sizing: border-box;
}
.resBox .resItem{
  width: 9vw;
    height: 9vw;
    line-height: 9vw;
    margin-right: 20px;
    background:linear-gradient(180deg, #fc78af, #f22678);
    border-radius: 50%;
    color: #fff;
    text-align: center
}
.ressquareBox{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(180deg, #fc78af, #f22678);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
}
.ballBox{
	border: 1px solid #606060;
  color: #606060;
    font-weight: 700;
    margin-right: 8px;
    font-size: 20px;width:40px
}
.list{
 padding: 4vw;
}
.list .item{
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}
</style>
